/* eslint-disable react/no-array-index-key */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import MediaItemPlayerCard from './MediaItemPlayerCard';

const MediaItemsList = (props) => {
  const {
    title,
    mediaItems,
    loading,
    error,
    selectedMediaItem,
    onSelectMediaItem,
  } = props;

  const handleSelectItem = useCallback(
    (mediaItem) => () => {
      onSelectMediaItem(mediaItem);
    },
    [onSelectMediaItem]
  );

  if (loading) {
    return (
      <Box mt={2} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={2} textAlign="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <Divider />
      <Grid container spacing={0}>
        {mediaItems.map((mediaItem, index) => (
          <Grid key={index} item xs={12}>
            <MediaItemPlayerCard
              selected={selectedMediaItem._id === mediaItem._id}
              mediaItem={mediaItem}
              onSelectItem={handleSelectItem(mediaItem)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

MediaItemsList.propTypes = {
  title: PropTypes.string,
  mediaItems: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,
  selectedMediaItem: PropTypes.object,

  onSelectMediaItem: PropTypes.func,
};

MediaItemsList.defaultProps = {
  title: '',
  mediaItems: [],
  loading: false,
  error: undefined,
  selectedMediaItem: {},
  onSelectMediaItem() {},
};

export default MediaItemsList;
